import { apiClient } from './client';
import type { DashboardSummary } from '../types/dashboard';

export const dashboardApi = {
  summary: () => apiClient.get<DashboardSummary>('/dashboard/summary/').then((r) => r.data),
};
